const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const getSuspendUnsuspend = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'SUSPEND_AGGING_SUMMARY_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'SUSPEND_AGGING_SUMMARY_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default getSuspendUnsuspend;